import { styled } from '@nykaa/ui-components';

export const Wrapper = styled.div<{ containerWidth?: number }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: ${({ containerWidth }) => `${containerWidth}px`};
  margin-left: auto;
  margin-right: calc(50% - 30px);
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.spacing10};
`;

export const Container = styled.div<{ position: number }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transform: translateX(${({ position }) => position}px);
  transition: 0.2s;
`;
